import React from 'react';
import './slider-foamstop-mm-pyramiddesign.css';
import Foampyramid1 from '../../images/FS-mm/fs7.webp';
import Foampyramid2 from '../../images/FS-mm/fs7.webp';
function slider() {
	return (
	  
	<>
	<div id="slider-foamstop-mm-pyramiddesign">
		<div id="carouselExampleIndicators3" className="carousel slide" data-ride="carousel">
  			<ol className="carousel-indicators">
    			<li data-target="#carouselExampleIndicators3" data-slide-to="0" className="active"></li>
    			<li data-target="#carouselExampleIndicators3" data-slide-to="1"></li>
  			</ol>
  			<div className="carousel-inner">
    			<div className="carousel-item active">
      				<img className="d-block w-100" src={Foampyramid1} alt="Foam Pyramid1" />
	  				<div className="carousel-caption d-none d-md-block">
					  	<h1>PYRAMID DESIGN</h1>
					</div>
				</div>
    			<div className="carousel-item">
      				<img className="d-block w-100" src={Foampyramid2} alt="Foam Pyramid2" />
	  				<div className="carousel-caption d-none d-md-block">
					  	<h1>PYRAMID DESIGN</h1>
					</div>
				</div>
			</div>
  			<a className="carousel-control-prev" href="#carouselExampleIndicators3" role="button" data-slide="prev">
    			<span className="carousel-control-prev-icon" aria-hidden="true"></span>
    			<span className="sr-only">Previous</span>
  			</a>
  			<a className="carousel-control-next" href="#carouselExampleIndicators3" role="button" data-slide="next">
    			<span className="carousel-control-next-icon" aria-hidden="true"></span>
    			<span className="sr-only">Next</span>
  			</a>
		</div>
	</div>
	</>
);
}
export default slider;